<template>
  <div 
    v-if="currentGame" 
    class="config-modal__wrap">
    <div class="modal-header">
      <span>Config launch url for {{ currentGame.name }}</span>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-3">
          <label>Game Mode:</label>
        </div>
        <div class="col-md-9">
          <div class="form-check">
            <input
              id="gameMode_1"
              v-model="form.funReal"
              class="form-check-input"
              type="radio"
              value="1"
              name="flexRadioDefault">
            <label 
              class="form-check-label" 
              for="gameMode_1">
              Real
            </label>
          </div>
          <div class="form-check">
            <input
              id="gameMode_2"
              v-model="form.funReal"
              class="form-check-input"
              type="radio"
              value="-1"
              name="flexRadioDefault">
            <label 
              class="form-check-label" 
              for="gameMode_2">
              Fun
            </label>
          </div>
        </div>
      </div><!-- /.row -->
      <div class="row">
        <div class="col-md-3">
          <label for="language">Language</label>
        </div>
        <div class="col-md-9">
          <select
            v-if="languages"
            id="language" 
            v-model="form.lang"
            class="form-select custom-select">
            <option 
              v-for="(language,i) in orderBy(languages, 'name')"
              :key="'language_' + i"
              :value="language.iso"
            >{{ language.name }} ( {{ language.iso.toUpperCase() }})</option>
          </select>
        </div>
      </div><!-- /.row -->
      <div class="row">
        <div class="col-md-3">
          <label for="currency">Currency</label>
        </div>
        <div class="col-md-9">
          <v-select
            v-if="currencies"
            v-model="form.currency"
            :options="currencies"
            :searchable="true"
            class="vue-select3"
            name="select3" /> 
        </div>
      </div><!-- /.row -->
      <div class="row">
        <div class="col-md-3">
          <label for="lobbyUrl">Lobby URL</label>
        </div>
        <div class="col-md-9">
          <input 
            id="lobbyUrl"
            v-model="form.lobbyURL"
            class="form-control"
            type="text" >
        </div>
      </div><!-- /.row -->
      <div class="row">
        <div class="col-md-3">
          <label for="cashierUrl">Cashier URL</label>
        </div>
        <div class="col-md-9">
          <input
            id="cashierUrl"
            v-model="form.cashierURL"
            class="form-control"
            type="text" >
        </div>
      </div><!-- /.row -->
      <!-- <div class="row">
        <div class="col-md-3">
          <label for="endpoint">Endpoint</label>
        </div>
        <div class="col-md-9">
          <select
            v-if="endpoints"
            id="endpoint"
            v-model="form.endpoint"
            class="form-select custom-select">
            <option
              v-for="(endpoint,i) in endpoints"
              :key="'endpoint_' + i"
              :value="endpoint"
            >{{ endpoint }}</option>
          </select>
<<<<<<< HEAD
        </div>  
      </div> /.row -->
 
 
			<div class="row">
				<div class="col-md-3">
					<label>No Wrapper</label>
				</div>
				<div class="col-md-9 noWrapper-options">
					<label>
						TRUE
						<input type="radio" value="true" v-model="form.noWrapper"/>
					</label>
					<label>
						FALSE
						<input type="radio" value="false" v-model="form.noWrapper"/>
					</label>
					<label>
						Not sent
						<input type="radio" value="-1" v-model="form.noWrapper"/>
					</label>
 
				</div>
			</div>
			<div class="row">
				<div class="col-md-3">
					<label>Jurisdiction</label>
				</div>
				<div class="col-md-9">
					<select class="form-select custom-select" v-model="form.jurisdiction">
						<option :value="el.value" v-for="(el, i) in jurisdiction" :key="`Jurisdiction${i}`">
							{{ el.label }}
						</option>
					</select> 
				</div>
			</div>
    </div>
    <div class="modal-footer">
      <button 
        class="btn btn-launch-game" 
        @click.prevent="createGameURL">
        <span>Launch game</span>
      </button>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import Vue2Filters from 'vue2-filters';
  import vSelect from 'vue-select';
  import 'vue-select/dist/vue-select.css';

  export default {
    name: "ConfigModal",
		components: { vSelect },
	  mixins: [Vue2Filters.mixin],
    data() {
      return {
      	languages: [],
	      currencies: [],
        endpoints: [],
        customUrl: '',
        wallets: [
          "seamless",
          "ecommerce",
        ],
        form: {
          funReal: 1,
          lang: 'en',
          currency: 'GBP',
          lobbyURL: 'https://www.crazybillions.com',
          cashierURL: 'https://www.crazybillions.com',
          endpoint: 'uat.cbcontents.com',
          walletType: 'seamless', 
          env: 'https://uat.cbcontents.com/',
					noWrapper: true,
					jurisdiction: -1,
 
        },
        envs: [], 
				jurisdiction: [
					{
						value: -1,
						label: "Not sent"
					},
					{
						value: 'ontario',
						label: 'Ontario',
					},
					{
						value: 'uk',
						label: 'UK',
					},
					{
						value: 'malta',
						label: 'Malta',
					}
				]
      }
    },
    computed: {
      ...mapGetters(['currentGame']),
    },
    async created() {
      this.path = process.env.NODE_ENV !== "development" ? '' : '';
      await this.getLanguages();
      await this.getCurrencies();
      await this.getEndpoints();
      await this.getEnvironments();
    },
    methods: {
      async getLanguages() {
      	try {
          const response = await this.axios.get(this.path + '/static/json/languages.json');
          if(response.data){
          	this.languages = response.data;
          }
        }catch(err) {}
      },
      async getCurrencies() {
      	try {
          const response = await this.axios.get(this.path + '/static/json/currencies.json');
          if(response.data) {
          	this.currencies = response.data;
          }
        }catch(err){}
      },
      async getEndpoints() {
      	try {
          const response = await this.axios.get(this.path + '/static/json/endpoints.json');
          if(response.data) {
          	this.endpoints = response.data;
          }
        }catch(err) {}
      },
      async getEnvironments() {
      	try {
      	  const response = await this.axios.get(this.path + '/static/json/environments.json');
      	  const {data} = response;
      	  if(data) {
      	  	this.envs = data;
          }
        }catch(err) {}
      },
      createGameURL() {
        var url = this.currentGame.link;

        for(let k in this.form) {
         /// let paramValue = (k === "currency") ? 'magma-' + this.form[k] : this.form[k];
       //   let paramKey = (k === "currency") ? 'sessionID' : k;
     //     url = this.queryStringUrlReplacement(url, paramKey, paramValue);
        }
	     // console.log(this.form);
        let currentParams = this.getQueryParams(url);

 
        let gameURL = `https://${this.form.endpoint}/marlipin/launch/cb.jsp?gameID=${currentParams.gameID}&sessionID=magma-${this.form.currency}&funReal=${this.form.funReal}&lobbyURL=${this.form.lobbyURL}&cashierURL=${this.form.cashierURL}&endpoint=${this.form.endpoint}&siteID=4&lang=${this.form.lang}&historyURL=${currentParams.historyURL}${this.form.noWrapper != -1 ? '&noWrapper='+this.form.noWrapper : ''}${this.form.jurisdiction != -1 ? '&jurisdiction=' + this.form.jurisdiction : ''}`;
 
				console.log(gameURL);
       	window.open(gameURL, '_blank');

      },
	    getQueryParams(url) {
		    const queryParams = url.split('&');

		    const uri = url.split('?');
		    if (uri.length === 2) {
			    const vars = uri[1].split('&');
			    const getVars = {};
			    let tmp = '';
			    vars.forEach((v) => {
				    tmp = v.split('=');
				    if (tmp.length === 2) { getVars[tmp[0]] = tmp[1]; }
			    });

			    return getVars;
		    }

		    const paramList = {};
		    for (const param of queryParams) {
			    const values = param.split('=');
			    paramList[values[0]] = values[1];
		    }
		    return paramList;
	    },
    },
  }
</script>

<style scoped>
	.noWrapper-options > * {
		margin-right: 1rem;
	}
</style>
 


// WEBPACK FOOTER //
// src/components/ConfigModal.vue